'use client';

import { useSearchParams } from 'next/navigation';
import { ChangelogEntry } from './changelog-entry';
import type { IChangelog } from './interface';

interface IChangelogPageProps {
  entries: IChangelog[];
  heading: string;
  lastUpdatedPrefix: string;
  intro: string;
}

export const ChangelogPage = ({
  entries,
  heading,
  lastUpdatedPrefix,
  intro,
}: IChangelogPageProps): React.JSX.Element => {
  const searchParams = useSearchParams();
  const selectedTag = searchParams.get('tag');

  const filteredChangelog = selectedTag
    ? entries.filter(
        (item) => item.tags?.includes(selectedTag) || item.description?.includes(`#${selectedTag}`),
      )
    : entries;

  return (
    <article className="max-w-3xl mx-auto px-4 py-8">
      <header className="mb-12 text-center">
        <h1 className="text-4xl/tight font-bold mb-4 pb-1 bg-linear-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent">
          {heading}
        </h1>
        <time className="text-sm text-muted-foreground" dateTime={entries[0]?.date}>
          {lastUpdatedPrefix} {entries[0]?.date}
        </time>
        <p className="mt-4 text-muted-foreground max-w-2xl mx-auto">{intro}</p>
      </header>

      <div className="space-y-12">
        {filteredChangelog.map((item) => (
          <ChangelogEntry key={item.date} item={item} />
        ))}
      </div>
    </article>
  );
};
